import React from 'react';
import TipTapFormField from 'external/TipTapEditor/TipTapFormField';
import type { SparkReferenceValue } from 'types/SparkStepReference';
import type { AttachmentsType } from './SparkBuilderDrawers/RightDrawer/forms/PromptAccordion';

type StepReferenceTextFieldProps = {
  name: string;
  label?: string;
  helpText?: string;
  subHeaderText?: string;
  placeholder?: string;
  isMultiline?: boolean;
  onchange?: (value: string) => void;
  disableReferenceInsertion?: boolean;
  handleFilesReference?: (value: SparkReferenceValue) => void;
  attachments?: AttachmentsType[];
  onAttachmentRemove?: (
    cardType: AttachmentsType['type'],
    id: AttachmentsType['id']
  ) => void;
};

function StepReferenceTextField({
  name,
  label,
  helpText,
  subHeaderText,
  placeholder = '',
  isMultiline = true,
  onchange,
  disableReferenceInsertion = false,
  handleFilesReference,
  attachments = [],
  onAttachmentRemove,
}: StepReferenceTextFieldProps) {
  return (
    <TipTapFormField
      name={name}
      label={label}
      helpText={helpText}
      subHeaderText={subHeaderText}
      isMultiLine={isMultiline}
      placeholderText={placeholder}
      attachments={attachments}
      onAttachmentRemove={onAttachmentRemove}
      onchange={onchange}
      disableReferenceInsertion={disableReferenceInsertion}
      handleFilesReference={handleFilesReference}
    />
  );
}

export default StepReferenceTextField;
